import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import RangeForm from '../../../components/forms/RangeForm';
import { useRangeApi } from '../../../hooks/useRangeApi';
import { useNavigate } from 'react-router-dom';
import { RangeDTO } from '../../../services/apiClient';

const RangeCreate: React.FC = () => {
  const { create, isLoading } = useRangeApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Ranges', href: '/admin/ranges' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: RangeDTO) => {
    try {
      await create(data);
      navigate(-1);
    } catch (error) {
      console.error('Error creating Range:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/ranges"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.Range.Edit'
    >
        <RangeForm
          initialValues={{} as RangeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate(-1)}
        />
    </AdminLayout>
  );
};

export default RangeCreate;